// Generated by scripts/generate-countries.mjs from world-countries 5.1.0. Do not edit by hand.
/** [ISO 3166-1 alpha-2, name, flag, continent, region]
 * Derived from world-countries (https://github.com/mledoze/countries), Open Database License (ODbL) 1.0. This derived
 * table is likewise available under the ODbL: https://opendatacommons.org/licenses/odbl/1.0/ */
export type CountryRow = readonly [code: string, name: string, flag: string, continent: string, region: string];
export const countries: readonly CountryRow[] = [
  ["AF","Afghanistan","🇦🇫","Asia","Southern Asia"],
  ["AX","Åland Islands","🇦🇽","Europe","Northern Europe"],
  ["AL","Albania","🇦🇱","Europe","Southeast Europe"],
  ["DZ","Algeria","🇩🇿","Africa","Northern Africa"],
  ["AS","American Samoa","🇦🇸","Oceania","Polynesia"],
  ["AD","Andorra","🇦🇩","Europe","Southern Europe"],
  ["AO","Angola","🇦🇴","Africa","Middle Africa"],
  ["AI","Anguilla","🇦🇮","North America","Caribbean"],
  ["AQ","Antarctica","🇦🇶","Antarctica","Antarctica"],
  ["AG","Antigua and Barbuda","🇦🇬","North America","Caribbean"],
  ["AR","Argentina","🇦🇷","South America","South America"],
  ["AM","Armenia","🇦🇲","Asia","Western Asia"],
  ["AW","Aruba","🇦🇼","North America","Caribbean"],
  ["AU","Australia","🇦🇺","Oceania","Australia and New Zealand"],
  ["AT","Austria","🇦🇹","Europe","Central Europe"],
  ["AZ","Azerbaijan","🇦🇿","Asia","Western Asia"],
  ["BS","Bahamas","🇧🇸","North America","Caribbean"],
  ["BH","Bahrain","🇧🇭","Asia","Western Asia"],
  ["BD","Bangladesh","🇧🇩","Asia","Southern Asia"],
  ["BB","Barbados","🇧🇧","North America","Caribbean"],
  ["BY","Belarus","🇧🇾","Europe","Eastern Europe"],
  ["BE","Belgium","🇧🇪","Europe","Western Europe"],
  ["BZ","Belize","🇧🇿","North America","Central America"],
  ["BJ","Benin","🇧🇯","Africa","Western Africa"],
  ["BM","Bermuda","🇧🇲","North America","North America"],
  ["BT","Bhutan","🇧🇹","Asia","Southern Asia"],
  ["BO","Bolivia","🇧🇴","South America","South America"],
  ["BA","Bosnia and Herzegovina","🇧🇦","Europe","Southeast Europe"],
  ["BW","Botswana","🇧🇼","Africa","Southern Africa"],
  ["BV","Bouvet Island","🇧🇻","Antarctica","Antarctica"],
  ["BR","Brazil","🇧🇷","South America","South America"],
  ["IO","British Indian Ocean Territory","🇮🇴","Africa","Eastern Africa"],
  ["VG","British Virgin Islands","🇻🇬","North America","Caribbean"],
  ["BN","Brunei","🇧🇳","Asia","South-Eastern Asia"],
  ["BG","Bulgaria","🇧🇬","Europe","Southeast Europe"],
  ["BF","Burkina Faso","🇧🇫","Africa","Western Africa"],
  ["BI","Burundi","🇧🇮","Africa","Eastern Africa"],
  ["KH","Cambodia","🇰🇭","Asia","South-Eastern Asia"],
  ["CM","Cameroon","🇨🇲","Africa","Middle Africa"],
  ["CA","Canada","🇨🇦","North America","North America"],
  ["CV","Cape Verde","🇨🇻","Africa","Western Africa"],
  ["BQ","Caribbean Netherlands","🇧🇶","North America","Caribbean"],
  ["KY","Cayman Islands","🇰🇾","North America","Caribbean"],
  ["CF","Central African Republic","🇨🇫","Africa","Middle Africa"],
  ["TD","Chad","🇹🇩","Africa","Middle Africa"],
  ["CL","Chile","🇨🇱","South America","South America"],
  ["CN","China","🇨🇳","Asia","Eastern Asia"],
  ["CX","Christmas Island","🇨🇽","Oceania","Australia and New Zealand"],
  ["CC","Cocos (Keeling) Islands","🇨🇨","Oceania","Australia and New Zealand"],
  ["CO","Colombia","🇨🇴","South America","South America"],
  ["KM","Comoros","🇰🇲","Africa","Eastern Africa"],
  ["CK","Cook Islands","🇨🇰","Oceania","Polynesia"],
  ["CR","Costa Rica","🇨🇷","North America","Central America"],
  ["HR","Croatia","🇭🇷","Europe","Southeast Europe"],
  ["CU","Cuba","🇨🇺","North America","Caribbean"],
  ["CW","Curaçao","🇨🇼","North America","Caribbean"],
  ["CY","Cyprus","🇨🇾","Europe","Southern Europe"],
  ["CZ","Czechia","🇨🇿","Europe","Central Europe"],
  ["DK","Denmark","🇩🇰","Europe","Northern Europe"],
  ["DJ","Djibouti","🇩🇯","Africa","Eastern Africa"],
  ["DM","Dominica","🇩🇲","North America","Caribbean"],
  ["DO","Dominican Republic","🇩🇴","North America","Caribbean"],
  ["CD","DR Congo","🇨🇩","Africa","Middle Africa"],
  ["EC","Ecuador","🇪🇨","South America","South America"],
  ["EG","Egypt","🇪🇬","Africa","Northern Africa"],
  ["SV","El Salvador","🇸🇻","North America","Central America"],
  ["GQ","Equatorial Guinea","🇬🇶","Africa","Middle Africa"],
  ["ER","Eritrea","🇪🇷","Africa","Eastern Africa"],
  ["EE","Estonia","🇪🇪","Europe","Northern Europe"],
  ["SZ","Eswatini","🇸🇿","Africa","Southern Africa"],
  ["ET","Ethiopia","🇪🇹","Africa","Eastern Africa"],
  ["FK","Falkland Islands","🇫🇰","South America","South America"],
  ["FO","Faroe Islands","🇫🇴","Europe","Northern Europe"],
  ["FJ","Fiji","🇫🇯","Oceania","Melanesia"],
  ["FI","Finland","🇫🇮","Europe","Northern Europe"],
  ["FR","France","🇫🇷","Europe","Western Europe"],
  ["GF","French Guiana","🇬🇫","South America","South America"],
  ["PF","French Polynesia","🇵🇫","Oceania","Polynesia"],
  ["TF","French Southern and Antarctic Lands","🇹🇫","Antarctica","Antarctica"],
  ["GA","Gabon","🇬🇦","Africa","Middle Africa"],
  ["GM","Gambia","🇬🇲","Africa","Western Africa"],
  ["GE","Georgia","🇬🇪","Asia","Western Asia"],
  ["DE","Germany","🇩🇪","Europe","Western Europe"],
  ["GH","Ghana","🇬🇭","Africa","Western Africa"],
  ["GI","Gibraltar","🇬🇮","Europe","Southern Europe"],
  ["GR","Greece","🇬🇷","Europe","Southern Europe"],
  ["GL","Greenland","🇬🇱","North America","North America"],
  ["GD","Grenada","🇬🇩","North America","Caribbean"],
  ["GP","Guadeloupe","🇬🇵","North America","Caribbean"],
  ["GU","Guam","🇬🇺","Oceania","Micronesia"],
  ["GT","Guatemala","🇬🇹","North America","Central America"],
  ["GG","Guernsey","🇬🇬","Europe","Northern Europe"],
  ["GN","Guinea","🇬🇳","Africa","Western Africa"],
  ["GW","Guinea-Bissau","🇬🇼","Africa","Western Africa"],
  ["GY","Guyana","🇬🇾","South America","South America"],
  ["HT","Haiti","🇭🇹","North America","Caribbean"],
  ["HM","Heard Island and McDonald Islands","🇭🇲","Antarctica","Antarctica"],
  ["HN","Honduras","🇭🇳","North America","Central America"],
  ["HK","Hong Kong","🇭🇰","Asia","Eastern Asia"],
  ["HU","Hungary","🇭🇺","Europe","Central Europe"],
  ["IS","Iceland","🇮🇸","Europe","Northern Europe"],
  ["IN","India","🇮🇳","Asia","Southern Asia"],
  ["ID","Indonesia","🇮🇩","Asia","South-Eastern Asia"],
  ["IR","Iran","🇮🇷","Asia","Southern Asia"],
  ["IQ","Iraq","🇮🇶","Asia","Western Asia"],
  ["IE","Ireland","🇮🇪","Europe","Northern Europe"],
  ["IM","Isle of Man","🇮🇲","Europe","Northern Europe"],
  ["IL","Israel","🇮🇱","Asia","Western Asia"],
  ["IT","Italy","🇮🇹","Europe","Southern Europe"],
  ["CI","Ivory Coast","🇨🇮","Africa","Western Africa"],
  ["JM","Jamaica","🇯🇲","North America","Caribbean"],
  ["JP","Japan","🇯🇵","Asia","Eastern Asia"],
  ["JE","Jersey","🇯🇪","Europe","Northern Europe"],
  ["JO","Jordan","🇯🇴","Asia","Western Asia"],
  ["KZ","Kazakhstan","🇰🇿","Asia","Central Asia"],
  ["KE","Kenya","🇰🇪","Africa","Eastern Africa"],
  ["KI","Kiribati","🇰🇮","Oceania","Micronesia"],
  ["XK","Kosovo","🇽🇰","Europe","Southeast Europe"],
  ["KW","Kuwait","🇰🇼","Asia","Western Asia"],
  ["KG","Kyrgyzstan","🇰🇬","Asia","Central Asia"],
  ["LA","Laos","🇱🇦","Asia","South-Eastern Asia"],
  ["LV","Latvia","🇱🇻","Europe","Northern Europe"],
  ["LB","Lebanon","🇱🇧","Asia","Western Asia"],
  ["LS","Lesotho","🇱🇸","Africa","Southern Africa"],
  ["LR","Liberia","🇱🇷","Africa","Western Africa"],
  ["LY","Libya","🇱🇾","Africa","Northern Africa"],
  ["LI","Liechtenstein","🇱🇮","Europe","Western Europe"],
  ["LT","Lithuania","🇱🇹","Europe","Northern Europe"],
  ["LU","Luxembourg","🇱🇺","Europe","Western Europe"],
  ["MO","Macau","🇲🇴","Asia","Eastern Asia"],
  ["MG","Madagascar","🇲🇬","Africa","Eastern Africa"],
  ["MW","Malawi","🇲🇼","Africa","Eastern Africa"],
  ["MY","Malaysia","🇲🇾","Asia","South-Eastern Asia"],
  ["MV","Maldives","🇲🇻","Asia","Southern Asia"],
  ["ML","Mali","🇲🇱","Africa","Western Africa"],
  ["MT","Malta","🇲🇹","Europe","Southern Europe"],
  ["MH","Marshall Islands","🇲🇭","Oceania","Micronesia"],
  ["MQ","Martinique","🇲🇶","North America","Caribbean"],
  ["MR","Mauritania","🇲🇷","Africa","Western Africa"],
  ["MU","Mauritius","🇲🇺","Africa","Eastern Africa"],
  ["YT","Mayotte","🇾🇹","Africa","Eastern Africa"],
  ["MX","Mexico","🇲🇽","North America","North America"],
  ["FM","Micronesia","🇫🇲","Oceania","Micronesia"],
  ["MD","Moldova","🇲🇩","Europe","Eastern Europe"],
  ["MC","Monaco","🇲🇨","Europe","Western Europe"],
  ["MN","Mongolia","🇲🇳","Asia","Eastern Asia"],
  ["ME","Montenegro","🇲🇪","Europe","Southeast Europe"],
  ["MS","Montserrat","🇲🇸","North America","Caribbean"],
  ["MA","Morocco","🇲🇦","Africa","Northern Africa"],
  ["MZ","Mozambique","🇲🇿","Africa","Eastern Africa"],
  ["MM","Myanmar","🇲🇲","Asia","South-Eastern Asia"],
  ["NA","Namibia","🇳🇦","Africa","Southern Africa"],
  ["NR","Nauru","🇳🇷","Oceania","Micronesia"],
  ["NP","Nepal","🇳🇵","Asia","Southern Asia"],
  ["NL","Netherlands","🇳🇱","Europe","Western Europe"],
  ["NC","New Caledonia","🇳🇨","Oceania","Melanesia"],
  ["NZ","New Zealand","🇳🇿","Oceania","Australia and New Zealand"],
  ["NI","Nicaragua","🇳🇮","North America","Central America"],
  ["NE","Niger","🇳🇪","Africa","Western Africa"],
  ["NG","Nigeria","🇳🇬","Africa","Western Africa"],
  ["NU","Niue","🇳🇺","Oceania","Polynesia"],
  ["NF","Norfolk Island","🇳🇫","Oceania","Australia and New Zealand"],
  ["KP","North Korea","🇰🇵","Asia","Eastern Asia"],
  ["MK","North Macedonia","🇲🇰","Europe","Southeast Europe"],
  ["MP","Northern Mariana Islands","🇲🇵","Oceania","Micronesia"],
  ["NO","Norway","🇳🇴","Europe","Northern Europe"],
  ["OM","Oman","🇴🇲","Asia","Western Asia"],
  ["PK","Pakistan","🇵🇰","Asia","Southern Asia"],
  ["PW","Palau","🇵🇼","Oceania","Micronesia"],
  ["PS","Palestine","🇵🇸","Asia","Western Asia"],
  ["PA","Panama","🇵🇦","North America","Central America"],
  ["PG","Papua New Guinea","🇵🇬","Oceania","Melanesia"],
  ["PY","Paraguay","🇵🇾","South America","South America"],
  ["PE","Peru","🇵🇪","South America","South America"],
  ["PH","Philippines","🇵🇭","Asia","South-Eastern Asia"],
  ["PN","Pitcairn Islands","🇵🇳","Oceania","Polynesia"],
  ["PL","Poland","🇵🇱","Europe","Central Europe"],
  ["PT","Portugal","🇵🇹","Europe","Southern Europe"],
  ["PR","Puerto Rico","🇵🇷","North America","Caribbean"],
  ["QA","Qatar","🇶🇦","Asia","Western Asia"],
  ["CG","Republic of the Congo","🇨🇬","Africa","Middle Africa"],
  ["RE","Réunion","🇷🇪","Africa","Eastern Africa"],
  ["RO","Romania","🇷🇴","Europe","Southeast Europe"],
  ["RU","Russia","🇷🇺","Europe","Eastern Europe"],
  ["RW","Rwanda","🇷🇼","Africa","Eastern Africa"],
  ["BL","Saint Barthélemy","🇧🇱","North America","Caribbean"],
  ["SH","Saint Helena, Ascension and Tristan da Cunha","🇸🇭","Africa","Western Africa"],
  ["KN","Saint Kitts and Nevis","🇰🇳","North America","Caribbean"],
  ["LC","Saint Lucia","🇱🇨","North America","Caribbean"],
  ["MF","Saint Martin","🇲🇫","North America","Caribbean"],
  ["PM","Saint Pierre and Miquelon","🇵🇲","North America","North America"],
  ["VC","Saint Vincent and the Grenadines","🇻🇨","North America","Caribbean"],
  ["WS","Samoa","🇼🇸","Oceania","Polynesia"],
  ["SM","San Marino","🇸🇲","Europe","Southern Europe"],
  ["ST","São Tomé and Príncipe","🇸🇹","Africa","Middle Africa"],
  ["SA","Saudi Arabia","🇸🇦","Asia","Western Asia"],
  ["SN","Senegal","🇸🇳","Africa","Western Africa"],
  ["RS","Serbia","🇷🇸","Europe","Southeast Europe"],
  ["SC","Seychelles","🇸🇨","Africa","Eastern Africa"],
  ["SL","Sierra Leone","🇸🇱","Africa","Western Africa"],
  ["SG","Singapore","🇸🇬","Asia","South-Eastern Asia"],
  ["SX","Sint Maarten","🇸🇽","North America","Caribbean"],
  ["SK","Slovakia","🇸🇰","Europe","Central Europe"],
  ["SI","Slovenia","🇸🇮","Europe","Central Europe"],
  ["SB","Solomon Islands","🇸🇧","Oceania","Melanesia"],
  ["SO","Somalia","🇸🇴","Africa","Eastern Africa"],
  ["ZA","South Africa","🇿🇦","Africa","Southern Africa"],
  ["GS","South Georgia","🇬🇸","Antarctica","Antarctica"],
  ["KR","South Korea","🇰🇷","Asia","Eastern Asia"],
  ["SS","South Sudan","🇸🇸","Africa","Middle Africa"],
  ["ES","Spain","🇪🇸","Europe","Southern Europe"],
  ["LK","Sri Lanka","🇱🇰","Asia","Southern Asia"],
  ["SD","Sudan","🇸🇩","Africa","Northern Africa"],
  ["SR","Suriname","🇸🇷","South America","South America"],
  ["SJ","Svalbard and Jan Mayen","🇸🇯","Europe","Northern Europe"],
  ["SE","Sweden","🇸🇪","Europe","Northern Europe"],
  ["CH","Switzerland","🇨🇭","Europe","Western Europe"],
  ["SY","Syria","🇸🇾","Asia","Western Asia"],
  ["TW","Taiwan","🇹🇼","Asia","Eastern Asia"],
  ["TJ","Tajikistan","🇹🇯","Asia","Central Asia"],
  ["TZ","Tanzania","🇹🇿","Africa","Eastern Africa"],
  ["TH","Thailand","🇹🇭","Asia","South-Eastern Asia"],
  ["TL","Timor-Leste","🇹🇱","Asia","South-Eastern Asia"],
  ["TG","Togo","🇹🇬","Africa","Western Africa"],
  ["TK","Tokelau","🇹🇰","Oceania","Polynesia"],
  ["TO","Tonga","🇹🇴","Oceania","Polynesia"],
  ["TT","Trinidad and Tobago","🇹🇹","North America","Caribbean"],
  ["TN","Tunisia","🇹🇳","Africa","Northern Africa"],
  ["TR","Türkiye","🇹🇷","Asia","Western Asia"],
  ["TM","Turkmenistan","🇹🇲","Asia","Central Asia"],
  ["TC","Turks and Caicos Islands","🇹🇨","North America","Caribbean"],
  ["TV","Tuvalu","🇹🇻","Oceania","Polynesia"],
  ["UG","Uganda","🇺🇬","Africa","Eastern Africa"],
  ["UA","Ukraine","🇺🇦","Europe","Eastern Europe"],
  ["AE","United Arab Emirates","🇦🇪","Asia","Western Asia"],
  ["GB","United Kingdom","🇬🇧","Europe","Northern Europe"],
  ["US","United States","🇺🇸","North America","North America"],
  ["UM","United States Minor Outlying Islands","🇺🇲","North America","North America"],
  ["VI","United States Virgin Islands","🇻🇮","North America","Caribbean"],
  ["UY","Uruguay","🇺🇾","South America","South America"],
  ["UZ","Uzbekistan","🇺🇿","Asia","Central Asia"],
  ["VU","Vanuatu","🇻🇺","Oceania","Melanesia"],
  ["VA","Vatican City","🇻🇦","Europe","Southern Europe"],
  ["VE","Venezuela","🇻🇪","South America","South America"],
  ["VN","Vietnam","🇻🇳","Asia","South-Eastern Asia"],
  ["WF","Wallis and Futuna","🇼🇫","Oceania","Polynesia"],
  ["EH","Western Sahara","🇪🇭","Africa","Northern Africa"],
  ["YE","Yemen","🇾🇪","Asia","Western Asia"],
  ["ZM","Zambia","🇿🇲","Africa","Eastern Africa"],
  ["ZW","Zimbabwe","🇿🇼","Africa","Eastern Africa"],
];
const byCode = new Map(countries.map(row => [row[0], row]));
export const countryOf = (code: string | null | undefined) => (code ? byCode.get(code.toUpperCase()) ?? null : null);
export const continents = [...new Set(countries.map(row => row[3]))].sort();
export const regions = [...new Set(countries.map(row => row[4]))].sort();
